var shopifyCartUrl = theme.routes.cart_url;
var shopifyCartAddUrl = theme.routes.cart_add_url + ".js";
var shopifyCartChangeUrl = shopifyCartUrl + "/change.js";
var shopifyCartClearUrl = shopifyCartUrl + "/clear.js";
var shopifyCartUpdateUrl = shopifyCartUrl + "/update.js";

var errorMessage = {
  error_add_to_cart: 'We encountered an error while adding your item to cart, please try again!'
};

// Initialize variables for item validation(s)
var validVariantKeys = [
  "frame_id",
  "lens_type_id",
  "lens_option_id",
  "plate_id",
  "case_id"
];
var validFrameKeys = [
  "line_group_id",
  "line_type",
  "tax_variant",
  "lens_index",
  "lens_type",
  "lens_usage",
  "lens_option",
  "case_selection",
  "plates",
  "collection",
  "lens_option_group",
  "frame_dimensions"
];
var validOptionKeys = [
  "line_group_id",
  "line_type",
  "collection"
];

/**
 * TODO:
 * - RX_ORDER_RELATION_CREATE
 *   > Replace host
 * - ENABLE_RX
 *   > Set to "true"
 * - job_ticket_url
 *   > Set to the correct job ticket's URL
 */
 let RX_ORDER_RELATION_CREATE = SHOPIFY_API + 'us/rx/api/prescriptions/orders/relation';
 let ENABLE_RX = true;
 let job_ticket_url = JOB_TICKET_DOMAIN + 'us/job-ticket/ec';
 let prescription_url = MYSHOPIFY_DOMAIN + "admin/apps/jins-prescription-custom";

var not_frame_id = ["lens_type_id", "lens_option_id", "plate_id", "case_id"];
var not_frame_product = ["lens-type-usage", "lens-option", "plate", "case"];
 
/**
 * Set variable for reference in showing screens in PDP modal (default is `true` means show the screen)
 * - use the element's ID as property for consistency
 *   > example: <div id="framesize" class="body-item">
 */
var modal_screen = {
  framesize: true,
  lenstype: true,
  lensoption: true,
  plate: true,
  case: true,
};

/**
 * Set variable for screen transition's default element's attributes
 * - use the element's ID as main property for consistency (with 2nd lvl properties for its wrapper and options' attributes)
 *   > example:
 *     <div ... data-body-content="lensoption">
 *       <input ... data-next-slide="lens_option_id">
 */
var screen_transition = {
  framesize: {
    bodyContent: "lenstype",
    nextSlide: "lens_type_id",
  },
  lenstype: {
    bodyContent: "lensoption",
    nextSlide: "lens_option_id",
  },
  lensoption: {
    bodyContent: "plate",
    nextSlide: "plate_id",
  },
  plate: {
    bodyContent: "case",
    nextSlide: "case_id",
  },
  case: {
    bodyContent: "case",
    nextSlide: "case_id",
  },
};

var selected_color = "";

var selected_plates = [];

var selected_product = {
  frame: "",
  lens_type: "",
  lens_option: "",
  plate: [],
  case: "",
};

var selected_variant = {
  frame_id: "",
  lens_type_id: "",
  lens_option_id: "",
  plate_id: [],
  case_id: "",
};

var lensUsage = "";

var tax_variant = "Prescription";

var current_slide = "";
var header_footer_height = "";

// Initialize an EMPTY array for miscellaneous random id
var misc_random_id = [];

// Initialize realtime `line_group_id`
var realtime_line_group_id = 1;

function addShadow() {
  $(".option-div-holder").each(function () {
    _this = $(this);

    var height = _this.height();

    _this.attr("data-height", height);

    var viewport_height = $(window).height();
    var total_height_diff =
      viewport_height -
      ($(".progress--body-group .item--content .text").height() + 100) -
      $(".template-product .drawer--group .drawer--price").height();
    header_footer_height =
      $(".progress--body-group .item--content .text").height() +
      180 +
      $(".template-product .drawer--group .drawer--price").height();

    if (height > total_height_diff) {
      _this.addClass("has-shadow");
    }

    setTimeout(function () {
      _this.css("max-height", `calc(${window.innerHeight}px - ` + header_footer_height + "px)");
    }, 100);

    $(window).resize(() => {
      _this.css("max-height", `calc(${window.innerHeight}px - ` + header_footer_height + "px)");
    });
  });
}

$(document).ready(function () {
  // generate default cart's note (if shopping cart page)
  if (window.location.pathname == shopifyCartUrl) {
    generateCartNote();
  }

  // load Swym then set correct class for `Add to Favorites` button
  var addToFavorites = $("#add-to-favorites");

  if (addToFavorites.length) {
    // call reset modal to initialize selected product and variant (to pass correct wishlist data)
    resetModal();

    function swymCallbackFn(swat) {
      evaluateWishList(addToFavorites);
    }

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(swymCallbackFn);
  }

  addShadow();

  $(".cc-announcement").clone().insertAfter(".header-clone .site-control");
  //call pdpchange
  pdpChanges();
  //check if products in cart belong to eyeglass or jins-switch collection and remove revive product accordingly
  if (
    $(".cart-list .item").length > 0 &&
    $(".cart-list .item.revive_items").length > 0
  ) {
    var eyeglassswitchcount = $(".cart-list").data("eyeglassswitchcount");
    if (eyeglassswitchcount == 0) {
      $(".cart-list .item.revive_items")
        .find(".remove_reconfigure a")
        .trigger("click");
    }
  }
 
  var currentURL = window.location.href;
  if( (currentURL.indexOf('/products') > -1 ) && (currentURL.indexOf('?swatch=') > -1 ) ){
    var checkswatch = currentURL.split('?swatch=')[1];
    $('select option').each(function(){
    var swatchtext =  $(this).val().toLowerCase().replace(/ /g,'-');
      if(swatchtext == checkswatch){
    var thisoption = $(this);
        $("select").val($(this).val()).change();
        $('.cc-swatches__label.option-label').text($(this).val());
        $(this).find('.js-option-color').trigger('click');
        setTimeout(function(){
          var btn = document.querySelector('.opt--'+swatchtext+'.js-option-color');
          let clickEvent = new Event('click');
          btn.dispatchEvent(clickEvent);

        }, 1000)
      }
    })
  }
var currentURL = window.location.href;

  if (currentURL.indexOf('/products') > -1
    && currentURL.indexOf('utm_campaign=') > -1
    && currentURL.indexOf("&from=qr_code") > -1) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const expectedSku = urlParams.get('utm_campaign');

    // Extract the SKU value
    const sku = current_variant_sku

    if(sku != expectedSku) {
      window.location.href = '/not-found'
    }

    // Hide menu
    const menuLink = document.querySelector('a.menu')
    if (menuLink) {
      menuLink.remove()
    }

    // Hide announcement
    const announcementElement = document.querySelector('div.cc-announcement')
    if (announcementElement) {
      announcementElement.remove()
    }

    // Hide productBreadcrumbs
    const productBreadcrumbs = document.querySelector('div.product-breadcrumbs')
    if (productBreadcrumbs) {
      productBreadcrumbs.remove()
    }

    // Hide navbar
    const navRightSide = document.querySelector('div.nav-right-side')
    if (navRightSide) {
      navRightSide.innerHTML = ''

      // Add new link
      const newAnchor = document.createElement('a');
      newAnchor.href = "/pages/favorites";
      newAnchor.className = "cart";
      newAnchor.innerHTML = `<svg width="30" height="26" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_57_59)">
      <path d="M17.5471 2.80593L14.9999 5.3531L12.4528 2.80593C11.1603 1.59268 9.44645 0.929937 7.67397 0.957953C5.90149 0.985969 4.20946 1.70255 2.95597 2.95604C1.70248 4.20953 0.985901 5.90156 0.957885 7.67404C0.929869 9.44652 1.59262 11.1604 2.80586 12.4528L5.35303 15L7.63336 17.2803L14.9999 24.6469L22.3665 17.2803L24.6468 15L27.194 12.4528C28.4073 11.1604 29.07 9.44652 29.042 7.67404C29.014 5.90156 28.2974 4.20953 27.0439 2.95604C25.7904 1.70255 24.0984 0.985969 22.3259 0.957953C20.5534 0.929937 18.8396 1.59268 17.5471 2.80593Z" fill="white" stroke="#231F20" stroke-width="2" stroke-miterlimit="10"></path>
    </g>
    <defs>
      <clipPath id="clip0_57_59">
        <rect width="30" height="25.7951" fill="white"></rect>
      </clipPath>
    </defs>
  </svg>`;
      newAnchor.style.setProperty('display', 'inline-block', 'important')
      navRightSide.appendChild(newAnchor)
    }

    // Hide virtual try on button
    const virtualButtons = document.querySelectorAll('#vto-btn')
    if (virtualButtons.length) {
      virtualButtons.forEach(
        virtualButton => virtualButton.remove()
      )
    }

    // Hide product slider
    const productSlider = document.querySelector('div.shopify-section.section-featured-collection')
    if (productSlider) {
      productSlider.remove()
    }

    // Hide pdp slider
    const pdpSlider = document.querySelectorAll('div.half-gutter.section-spacing.pdp-slider')
    if (pdpSlider.length) {
      pdpSlider.forEach(slide => slide.remove())
    }

    // Hide footer
    const footer = document.querySelector('div.wide-container.section-footer__row-container')
    if (footer) {
      footer.remove()
    }

    // Hide select lenses button 
    const priceArea = document.querySelector('div.price-buttons-area')
    if(priceArea) {
      const oldButton = priceArea.querySelector('.product-select-lenses');

      if (oldButton) {
        const newButton = document.createElement('button');
        
        newButton.textContent = "CHECK IN NOW"
        newButton.className = "btn-select-store"
        newButton.addEventListener('click', function (e) {
          e.preventDefault()
          const searchUrl = window.location.search?.replace('&from=qr_code', '');
          if (currentURL.includes('us-stg')) {
            window.location.href = "https://us-storeselect-stg.jins.com/index.html" + searchUrl;
          } else {
            window.location.href = "https://us-storeselect.jins.com/index.html" + searchUrl;
          }
        })

        priceArea.replaceChild(newButton, oldButton);
      }
    }
  
    // Hide other color
    setTimeout(() => {
      const links = document.querySelectorAll('a.js-option-color:not(.active)');
      links.forEach(function (link) {
        const li = link.closest('li');
        if (li) {
          li.remove()
        }
      })
    }, 500)

    // Hide menu in pc mode
    const getPCMenuLink = document.querySelectorAll('.site-control__inline-links')
    if (getPCMenuLink.length) {
      getPCMenuLink.forEach(menu => menu.remove())
    }

    // Hide button add write a review
    setTimeout(() => {
      const yotpoState = document.querySelector('div.yotpo-empty-state')
      if (yotpoState) {
        yotpoState.remove()
      }
      const yotpoButton = document.querySelector('div.yotpo-new-review-btn-wrapper')
      if (yotpoButton) {
        yotpoButton.remove()
      }
    }, 1000)
  }
  initColorSwatchToURL();
});

$(".js-product-item-size").bind("click", function () {
  frame_id = $(this).data("productid");
});

$(".js-option-lens-usage").hide();
$(".js-option-selection").click(function () {
  var productOption = $(this).attr("data-product-option");
  var optionValue = $(this).val();
  var current_slide = $(this).attr("data-next-slide");

  if (current_slide) {
    $(".progress--body").attr("class", "progress--body");
    $(".progress--body").attr("data-current-slide", current_slide);
    setTimeout(() => {
      $(".progress--body").addClass(current_slide);
    }, 100);
  }

  switch (productOption) {
    // Lens Type & Usage Selection
    case "lens-type-usage":
      updateFrameVariant(optionValue);
      break;

    // Lens Option Selection
    case "lens-option":
      getProductInfo(optionValue, tax_variant, products[1]);

      $("#option-lens-option").val(optionValue);
      break;

    // Plate Selection
    case plate:
      const container = $(this).parent().parent();
      container.toggleClass("selected");

      if (selected_plates.includes(optionValue)) {
        selected_plates = selected_plates.filter(x => x !== optionValue);
        getProductInfo(optionValue, tax_variant, products[3], true);
      } else {
        selected_plates = [...selected_plates, optionValue];
        getProductInfo(optionValue, tax_variant, products[3]);
      }
      
      $("#js-plate-counter").text(`${selected_plates.length} Item${selected_plates.length > 1 ? 's' : ''} Selected`);
      $(".js-progress-button.plate").toggleClass("disabled", selected_plates.length === 0);

      break;

    // Case Selection
    case "case":
      getProductInfo(optionValue, tax_variant, products[2]);

      $("#option-case").val(optionValue);
      break;
  }

  addShadow();

});

$(".js-option-lens-usage label").click(function () {
  lensUsage = $(this).text();
});

/**
 * Event handler for `previous` cta
 */
$(".option-back").click(function () {
  let resetId = $(this).attr("data-previous-content");
  let optionName = $(this).attr("data-price-option");

  // if from `Select Reader Lens Power` screen then make sure transition is correct
  toggleReaderLensPower();

  // reset previous selected variant
  selected_variant[resetId] = "";
  selected_variant["case_id"] = "";

  // reset previous selected option
  $('input[name="' + resetId + '"]').prop("checked", false);
  $(".js-product-item-size").removeClass("active");

  resetPlateObjects();

  // reset price attribute(s) and recalculate Subtotal
  if (optionName != "") {
    var total = 0;
    var price = document.querySelector(".theme-money-modal");

    price.setAttribute("data-" + optionName + "-price", 0);

    // verify and reset previous selected variant(s) & price attributes
    if (optionName == plate) {
      selected_variant["case_id"] = "";
      $('input[name="case_id"]').prop("checked", false);

      price.setAttribute("data-case-price", 0);
    }

    for (let i = 1; i < price.attributes.length; i++) {
      total = Number(price.attributes[i].value) + total;
    }

    price.innerHTML = theme.Shopify.formatMoney(
      total,
      "${{amount_no_decimals}}",
      theme.money_format_with_code_preference
    );
  }


  var current_slide = resetId;

  $(".progress--body").attr("class", "progress--body");
  $(".progress--body").attr("data-current-slide", current_slide);
  setTimeout(() => {
    $(".progress--body").addClass(current_slide);
  }, 100);

  validateAddToCart();
});

$(".option-lens-usage .option-back").click(function () {
  $(".option-lens-usage").addClass("hidden");
});

$(".option-field.readers").click(function () {
  $(".option-lens-usage").removeClass("hidden");
  $("#lenstype .option--lens-type").css("right", "100%");
});

const resetPlateObjects = () => {
  platePrice = 0;
  selected_plates = [];
  selected_product.plate = [];
  selected_variant.plate_id = [];
  $(".js-option-selection.plate").each((_i, e) => {
    $(e).parent().parent().removeClass("selected")
  });
  $("#js-plate-counter").text("0 Item Selected");
  $(".js-progress-button.plate").toggleClass("disabled", true);
}

/**
 * Event handler for `Add to cart` button
 */
 var addedToCart = false

 $(".js-add-to-cart").click(function () {
   // make sure to fetch current cart in order to set a realtime `line_group_id`
   $(this).text('Adding..');
   if(addedToCart) return
   addedToCart = true 
  
  fetch("/cart.js")
    .then((response) => response.text())
    .then((data) => {
      data = JSON.parse(data);

      let countCartItem = 0;

      $.each(data.items, function (key, value) {
        if (value.properties.line_type == "frame_id" || value.properties.line_type == "others") {
          countCartItem++;
        }
      });
      
      realtime_line_group_id = countCartItem + 1;

      if ($(this).hasClass("product-select-lenses")) {
        jinsAddToCartNoLens();
      } else {
        jinsAddToCart();
      }
    }).catch((error) => {
      // Display validation message
      toggleItemValidation(errorMessage.error_add_to_cart);
    });
});

/**
 * Event handler for `Remove` an item and `Decrease` or `Increase` quantity of an item in the shopping cart page
 */
$('.js-remove-item, .js-minus-quantity, .js-plus-quantity, .reconfigure_option').click(function () {
  var lineGroupId = $(this).attr('data-line-group');
  var lineId = $(this).attr('data-id');
  $('#cart_action_loader').text('Updating...');
  $('#cart_action_loader').removeClass('visually-hidden');
  if(lineGroupId){
     removeCartItem(lineGroupId);
  }else{
      removeItem(lineId);
  }
  return false;
});

function removeItem(id) {
  let variantId =id;
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: variantId,
      quantity: 0,
    },
  }).then((data) => {
   window.location.href="/cart";
  });
}

/**
 * Creates and displays a prescription modal, allowing the user to choose between two options:
 * logging in to use a saved prescription or continuing as a guest to enter a new prescription.
 *
 * @return {Promise<number>} Resolves with a value of `1` if the user selects the login option,
 * or `2` if the user selects the guest option.
 */
function choosePrescriptionSourceModal() {
  return new Promise((resolve) => {
    const modalHTML = `
      <div id="prescriptionModal" style="
        position: fixed; top: 0; left: 0; right: 0; bottom: 0;
        background: rgba(0, 0, 0, 0.4); z-index: 9999;
        display: flex; justify-content: center; align-items: center;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
      ">
        <div style="
          background: white;
          border-radius: 16px;
          padding: 40px 24px;
          width: 100%;
          max-width: 360px;
          text-align: center;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          position: relative;
        ">
        
          <button id="modal-close-btn" style="
            position: absolute;
            top: 12px;
            right: 12px;
            background: transparent;
            border: none;
            font-size: 24px;
            font-weight: bold;
            cursor: pointer;
            color: #666;
          " aria-label="Close modal">&times;</button>
        
          <h2 style="font-size: 22px; letter-spacing: 1px; font-weight: 500; color: #333; margin-bottom: 4px;">
          <img src="//cdn.shopify.com/s/files/1/0562/8903/4283/files/JINS-Logo111_52173832-6a06-4b92-8729-814cac404de9_500x.png?v=1655911394" alt="JINS Eyewear US, Inc STG" itemprop="logo" width="100" height="100">
          </h2>
          <h3 style="font-size: 22px; font-weight: 500; margin: 16px 0;">Would you like to sign in?</h3>
          <pre style="font-size: 13px; line-height: 1.5; margin-left: 13px; text-align: left; font-family: JINS_NextLight">
Sign in to:
  ・View your past prescriptions
  ・Save your purchase history
  ・Access everything in the app
              </pre>
          <button id="login-btn" style="
            width: 100%;
            padding: 12px 16px;
            margin-bottom: 12px;
            border: 1px solid #ccc;
            border-radius: 9999px;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
          ">
            Sign in
          </button>
          <button id="guest-btn" style="
            width: 100%;
            padding: 12px 16px;
            border: 1px solid #ccc;
            border-radius: 9999px;
            background: white;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            color: #000000;
          ">
            Continue as guest
          </button>
        </div>
      </div>
    `;

    $("body").append(modalHTML);

    $(document).on("click", "#login-btn", function () {
      $("#prescriptionModal").remove();
      resolve(1); // 1 = login
    });

    $(document).on("click", "#guest-btn", function () {
      $("#prescriptionModal").remove();
      resolve(2); // 2 = guest
    });

    $(document).on("click", "#modal-close-btn", function () {
      $("#prescriptionModal").remove();
      resolve(0); // 0 = close modal
    });
  });
}

var job_ticket_created_flag = false;
/**
 * Event handler for `Checkout` button
 */
$(".js-checkout-btn").click(async function (e) {

  /**
   * Send request create job ticket and checkout
   * */
  async function createJobTicketAndCheckout() {
    // set hidden field's value as 1 (reference for clicked `Checkout`)
    $("#is-checkout").val(1);

    if (job_ticket_created_flag) {
      job_ticket_created_flag = false;
      return;
    }

    $("#cart_action_loader").text("Processing...");
    $("#cart_action_loader").removeClass("visually-hidden");

    e.preventDefault();
    await addJobTicket(function () {
      job_ticket_created_flag = true;
      $(".js-checkout-btn").click();
    });
  }

  if (!job_ticket_created_flag) {
    e.preventDefault();
    const customers = window.shopifyCustomer || []
    const isRequiredPrescription = cartItems.some(item => item.properties?.tax_variant === 'Prescription');
    const isLoggedIn = customers.length > 0;
    if (!isLoggedIn && isRequiredPrescription) {
      const modalElm = $('#prescriptionModal');
      if (!modalElm.length) {
        const choice = await choosePrescriptionSourceModal();
        if (choice === 0) {
          modalElm.remove();
          return;
        }
        await createJobTicketAndCheckout();
        if (choice === 1) {
          window.location.href = JINS_AUTH0_DOMAIN + 'login/shopify?returnTo=/pages/add-prescription';
        } else if (choice === 2) {
          window.location.href = 'pages/add-prescription';
        }
      }
    } else if (isLoggedIn && isRequiredPrescription) {
      await createJobTicketAndCheckout();
      window.location.href = 'pages/add-prescription';
    } else {
      window.location.href = theme.routes.checkout || 'checkout';
    }
  }
});

/**
 * Event handler for form submission in the shopping cart page
 */
$("#cartform").submit(function (event) {
  var isCheckout = $("#is-checkout").val();

  if (isCheckout != 1) {
    event.preventDefault();

    submitShoppingCart();
  }
});

/**
 * Event handler for cart's note
 */
$("#fakenote").on("change keyup paste", function () {
  generateCartNote();
});

function getProductInfo(item, prescription, index, isRemove = false) {
  for (var i = 0; index.products.length > i; i++) {
    if (index.products[i].handle == item) {
      index.products[i].variants.forEach((element) => {
        if (element.name == prescription) {
          if (index.name == "lens-type-usage") {
            selected_product.lens_type = index.products[i];
            selected_variant.lens_type_id = element.id;
          } else if (index.name == "lens-option") {
            selected_product.lens_option = index.products[i];
            selected_variant.lens_option_id = element.id;
          } else if (index.name == "case") {
            selected_product.case = index.products[i];
            selected_variant.case_id = element.id;
          } else if (index.name == plate) {
            if (isRemove) {
              selected_product.plate = selected_product.plate.filter(x => x.id !== index.products[i].id);
              selected_variant.plate_id = selected_variant.plate_id.filter(x => x !== element.id);
            } else {
              selected_product.plate = [...selected_product.plate, index.products[i]];
              selected_variant.plate_id = [...selected_variant.plate_id, element.id];
            }
          }
        }
      });
    } else {
      if (index.products[i].id == item) {
        for (let j = 0; j < index.products[i].variants.length; j++) {
          if (index.products[i].variants[j].name == tax_variant) {
            selected_product.frame = index.products[i];
            selected_variant.frame_id = index.products[i].variants[j].id;
            selected_product.cprops = index.products[i].cprops;
            selected_product.note = index.products[i].note;

            if (not_frame_product.indexOf(index.name) < 0) {
              toggleAddToCart(index.products[i].variants[j].stock);
            }
          }
        }
      }
    }

    validateAddToCart();
  }
}

/**
 * Event handler for `Add to Favorites` button
 */
$("#add-to-favorites").click(function (event) {
  var elem = $(this);
  var wishlistData = {};
  var productUrl = elem.attr('data-product-url');
  
  event.preventDefault();
  if (selected_product.frame.id) {
    wishlistData = {
      epi: selected_variant.frame_id,
      du: `${window.location.origin}/products/${product.handle}`,
      empi: selected_product.frame.id,
      cprops: selected_product.cprops || selected_product.frame.cprops,
      note: selected_product.note || selected_product.frame.note,
    };
  } else {
    wishlistData = {
      epi: currentProductVariant[0].current_variant.id,
      du: `${window.location.origin}/products/${product.handle}`,
      empi: parseInt(currentProductVariant[0].id),
      cprops: currentProductVariant[0].cprops,
      note: currentProductVariant[0].note,
    };
  }

  if (elem.hasClass('swym-added')) {
    window._swat.removeFromWishList(wishlistData, function() {
      elem.removeClass('disabled swym-added swym-adding swym-removing');
    });
  } else {
    window._swat.addToWishList(wishlistData, function () {
      elem.addClass("disabled swym-added swym-adding");
      elem[0].addEventListener("mouseout", (event) => {
        elem.removeClass("swym-adding");
      });
      elem[0].removeEventListener("mouseout", (event) => {
        elem.removeClass("swym-adding");
      });
    });
  }
});

/**
 * Function to toggle `Add to Cart` or `Out of stock` button
 *
 * @param {number} inventoryQuantity
 */
function toggleAddToCart(inventoryQuantity) {
  var cartButtonText = theme.strings.buttonDefault;
  var outOfStock = false;
  var modalButton = $(".js-options-modal-button");
  var addCartButton = document.querySelector(".js-add-to-cart");

  // default text for modal button "Select Lenses"
  modalButton.text("Add to Cart");

  if (inventoryQuantity <= 0) {
    outOfStock = true;
    cartButtonText = theme.strings.buttonNoStock;

    // show "Out of Stock" button earlier
    modalButton.text(cartButtonText);
  }

  $(".js-add-to-cart").prop("disabled", outOfStock);

  if (cartButtonText == "Out of stock") {
    addCartButton.setAttribute("disabled", true);
    addCartButton.classList.add("disabled");
  } else {
    addCartButton.setAttribute("disabled", false);
    addCartButton.classList.remove("disabled");
  }

  // set disabled property for `Add to Cart` or `Out of Stock` button
  modalButton.prop("disabled", outOfStock);

  addShadow();
  pdpChanges();
}

/**
 * Function to validate `Add to Cart` button
 * - Make sure that all frame options are provided to enable
 */
function validateAddToCart() {
  var disableButton = false;

  if (
    selected_variant.case_id == ""
  ) {
    disableButton = true;

    $(".js-add-to-cart").hide();
  } else {
    $(".js-add-to-cart").show();
  }

  $(".js-add-to-cart").prop("disabled", disableButton);

  if (product.tags.includes("plate-product")) {
    $(".js-add-to-cart").show();
    $(".js-add-to-cart").prop("disabled", false);
  }

  addShadow();
}

/**
 * Another function for add to cart (NO LENS OPTION)
 * - Static variant IDs:
 *   > VALE: 40075133911083
 *   > Test Frame Product 5: 40275796426795
 */
function jinsAddToCartNoLens() {
  var productToAdd = currentProductVariant[0];
  var currentVariantId = productToAdd.current_variant.id;
  
  if (
    (productToAdd.tags.indexOf("main-product") !== -1 ||
    productToAdd.tags.indexOf("sub-product") !== -1) &&
    productToAdd.tags.indexOf("plate-product") === -1
  ) {
    if(productToAdd.lens_type == '' && productToAdd.case == '' && productToAdd.frame_color == '' && productToAdd.frame_dimensions){
      // Display validation message
      toggleItemValidation(errorMessage.error_add_to_cart);
    }
      
    var lineItemProperties = {
      line_group_id: realtime_line_group_id,
      line_type: "frame_id",
      tax_variant: "Non-Prescription",
      lens_index: "",
      lens_type: productToAdd.lens_type,
      lens_usage: "",
      lens_option: "",
      case_selection: productToAdd.case,
      frame_color: productToAdd.frame_color,
      frame_dimensions: productToAdd.frame_dimensions,
      handle: productToAdd.handle,
      collection: $("#collection").val(),
    };
  } else {
    var lineItemProperties = {
      line_group_id: realtime_line_group_id,
      line_type: "others",
      is_plate: productToAdd.tags.indexOf("plate-product") > -1
    };
  }

  // Set current variant ID for `non-prescription` (if exists)
  if (productToAdd.hasOwnProperty("non_prescription")) {
    currentVariantId = productToAdd.non_prescription.id;
  }

  // If product is plate as main product
  if (productToAdd.tags.indexOf("plate-product") > -1) {
    currentVariantId = selected_product.frame.variants[1].id;
  }

  var cartItems = {
    items: [],
  };

  cartItems["items"].push({
    id: currentVariantId,
    quantity: 1,
    properties: lineItemProperties,
  });

  fetch(shopifyCartAddUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(cartItems),
  })
    .then((data) => {
      window.location.href = shopifyCartUrl;
    })
    .catch((error) => {
    //   console.error("Error:", error);
    });
}

/**
 * New function for add to cart (From Shopify Cart API Reference)
 * - https://shopify.dev/api/ajax/reference/cart
 */
function jinsAddToCart() {
  var productsDataArray = [];
  var selectedVariantKeys = Object.keys(selected_variant);

  // declare variable to check all keys must exists in the `selected_variant`
  var hasAllVariantKeys = validVariantKeys.every(elem => selectedVariantKeys.includes(elem));

  if (hasAllVariantKeys) {
    // Loop thru the selected variant
    $.each(selected_variant, function (key, value) {
      if (typeof value == "number") {
        var lineItemProperties = {
          line_group_id: realtime_line_group_id,
          line_type: key,
          collection: $("#collection").val(),
        };

        if (not_frame_id.indexOf(key) < 0) {
          lineItemProperties = {
            line_group_id: realtime_line_group_id,
            line_type: key,
            tax_variant: tax_variant,
            lens_index: "",
            lens_type: selected_product.lens_type.title,
            lens_usage: lensUsage,
            lens_option: selected_product.lens_option.title,
            case_selection: selected_product.case.title,
            plates: selected_product.plate.map(x => x.title).join(";"),
            collection: $("#collection").val(),
            lens_option_group: selected_product.lens_option.group,
            frame_dimensions: selected_product.frame?.custom_attributes ?
              selected_product.frame?.custom_attributes["frame-dimensions"] : "",
          };
        }

        productsDataArray.push({
          id: value,
          quantity: 1,
          properties: lineItemProperties,
        });
      } else if (Array.isArray(value)) {
        value.forEach(val => {
          var lineItemProperties = {
            line_group_id: realtime_line_group_id,
            line_type: key,
            collection: $("#collection").val(),
          };
    
          if (not_frame_id.indexOf(key) < 0) {
            lineItemProperties = {
              line_group_id: realtime_line_group_id,
              line_type: key,
              tax_variant: tax_variant,
              lens_index: "",
              lens_type: selected_product.lens_type.title,
              lens_usage: lensUsage,
              lens_option: selected_product.lens_option.title,
              case_selection: selected_product.case.title,
              plates: selected_product.plate.map(x => x.title).join(";"),
              collection: $("#collection").val(),
              lens_option_group: selected_product.lens_option.group,
              frame_dimensions: selected_product.frame?.custom_attributes ?
                selected_product.frame?.custom_attributes["frame-dimensions"] : "",
            };
          }
    
          productsDataArray.push({
            id: val,
            quantity: 1,
            properties: lineItemProperties,
          });
        });
      }

      var hasAllItemKeys = true;
      switch (key) {
        case 'frame_id':
          hasAllItemKeys = validFrameKeys.every(elem => Object.keys(lineItemProperties).includes(elem));
          if (!hasAllItemKeys) {
            // Display validation message
            toggleItemValidation(errorMessage.error_add_to_cart);
          }
          break;

        case 'lens_type_id':
          hasAllItemKeys = validOptionKeys.every(elem => Object.keys(lineItemProperties).includes(elem));
          if (!hasAllItemKeys) {
            // Display validation message
            toggleItemValidation(errorMessage.error_add_to_cart);
          }
          break;

        default:
          break;
      }
    });

    var cartItems = {
      items: [],
    };

    for (var i = 0; i < productsDataArray.length; i++) {
      cartItems["items"].push({
        id: productsDataArray[i]["id"],
        quantity: productsDataArray[i]["quantity"],
        properties: productsDataArray[i]["properties"],
      });
    }

    fetch(shopifyCartAddUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(cartItems),
    })
      .then((data) => {
        window.location.href = shopifyCartUrl;
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  } else {
    // Display validation message
    toggleItemValidation(errorMessage.error_add_to_cart);
  }
}

/**
 * Function to submit shopping cart
 */
function submitShoppingCart() {
  var itemsToUpdate = {};
  var inputQuantity = $("input.js-change-quantity");

  $.each(inputQuantity, function (i, obj) {
    lineGroupId = $(obj).attr("data-line-group");
    quantity = $(obj).val();

    $.each(cartItems, function (key, value) {
      if (value.line_group_id === lineGroupId) {
        itemsToUpdate[value.id] = quantity;
      }
    });
  });

  updateShoppingCart(itemsToUpdate);
}

/**
 * Function to generate `relation_id` per frame product and update `job_ticket` in the shopping cart
 *
 */
async function addJobTicket(_createdJobTicketCallback) {
  // localStorage.removeItem("jobTickets");
  var jobTickets = [];

  // retrieve localStorage.jobTickets
  var lsJobTickets = JSON.parse(localStorage.getItem('jobTickets'));

  // initialize an array for list of `relation_id`
  var relationIds = [];

  // map existing `lsJobTickets` as new array for `relationIds`
  if (lsJobTickets !== null && lsJobTickets.length) {
    relationIds = $.map(lsJobTickets, function(elem) {
      return elem.id;
    });
  }

  // add function call to check expiry of token

  for (const value of cartItems) {
    var itemProperties = value.properties;
    if (
      itemProperties.hasOwnProperty("line_type") &&
      (itemProperties.line_type == "frame_id" || itemProperties.line_type == "others")
    ) {
      if (ENABLE_RX) {
        if (relationIds.length >= itemProperties.line_group_id) {
          // retain the previous generated `relation_id`
          relation_id = relationIds[itemProperties.line_group_id - 1];
        } else {
          // generate new `relation_id`
          const { data } = await fetch(RX_ORDER_RELATION_CREATE, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          }).then((response) => response.json());

          if (typeof data.id !== "undefined") {
            relation_id = data.id;
          }else{
            throw new Error(errorMessage.error_add_to_cart);
          }
        }
      } else {
        // temporarily set value (hardcoded for testing ONLY)
        relation_id = (Math.random() * 9999) | 1;
      }

      jobTickets.push({
        id: relation_id,
        line_group_id: itemProperties.line_group_id,
        isPrescription:
          itemProperties.tax_variant &&
          itemProperties.tax_variant.toLowerCase() === "prescription"
            ? true
            : false,
      });

      itemProperties['job_ticket'] = `${job_ticket_url}?relation_id=${relation_id}`;

      if (itemProperties.line_type == "frame_id") {
        itemProperties['prescription'] = `${prescription_url}?relation_id=${relation_id}`;
      }
      
      itemProperties['relation_id'] = relation_id;

      changeCartItems = {
        id: value.key,
        properties: itemProperties,
      };

      // regenerate cart's note
      // generateCartNote();

      await fetch(shopifyCartChangeUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(changeCartItems),
      })
        .then(() => {})
        .catch((error) => {
        //   console.error("Error:", error);
        });
    }
  }
  
  localStorage.setItem("jobTickets", JSON.stringify(jobTickets));

  _createdJobTicketCallback();
}

/**
 * Function to update cart items using fetch then reload the shopping cart page
 *
 * @param {array} itemsToUpdate
 */
function updateShoppingCart(itemsToUpdate) {

  fetch(shopifyCartUpdateUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      updates: itemsToUpdate,
    }),
  })
    .then((data) => {
      window.location.href = shopifyCartUrl;
    })
    .catch((error) => {
    //   console.error("Error:", error);
    });
}

/**
 * Function to generate cart's note in JSON format
 *
 * - Asana ticket (for JSON object reference)
 *   > https://app.asana.com/0/1200029089277897/1202658032078392/f
 */
function generateCartNote() {
  var fakeNote = $("#fakenote").val();
  var lineGroups = generateLineGroups();

  // Set note JSON obj
  var cartNote = {
    order_note: fakeNote,
    selected_prescription_value: "",
    ers: {
      staff_name: "",
      shipping_method: "",
      store_address: "",
      staff_id: "",
      is_ers: false,
      prescription_id: "",
    },
    line_groups: lineGroups,
  };
  
  jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
    note: JSON.stringify(cartNote)
  });
  // $("#note").text(JSON.stringify(cartNote));
}

/**
 * Function to generate line groups for Order Data JSON object
 *
 * @return array
 */
function generateLineGroups() {
  var lineGroups = [];

  var itemFrame = "";
  var itemLens = "";
  var itemLensColor = "";
  var itemCase = "";
  var itemPlate = [];
  var relationId = "";

  // console.log(">>> BEGIN generateLineGroups!!!");
  $.each(cartItems, function (key, value) {
    // console.log("value.line_group_id: ", value.line_group_id);
    switch (value.properties.line_type) {
      case "plate_id":
        itemPlate = [...itemPlate, {
          line_id: value.id,
          plate: value.title,
          plate_discount: parseInt(value.discounted_price),
          plate_price: parseInt(value.price),
        }];

        break;

      case "case_id":
        itemCase = {
          line_id: value.id,
          case: value.title,
          case_discount: parseInt(value.discounted_price),
          case_price: parseInt(value.price),
        };

        break;

      case "lens_type_id":
        // update `lens` properties
        itemLens.line_id = value.id;
        itemLens.lens_color_discount = parseInt(value.discounted_price);
        itemLens.lens_color_price = parseInt(value.price)
        break;

      case "lens_option_id":
        // update `lens_color` properties
        itemLensColor.line_id = value.id;
        itemLensColor.lens_color_discount = parseInt(value.discounted_price);
        itemLensColor.lens_color_price = parseInt(value.price)
        break;

      case "frame_id":
        relationId = value.properties.relation_id;

        // set `frame` properties
        itemFrame = {
          line_id: value.id,
          frame_name: value.title,
          frame_sku: value.sku,
          frame_discount: parseInt(value.discounted_price),
          frame_price: parseInt(value.price),
          job_ticket: parseInt(relationId)
            ? `${job_ticket_url}?relation_id=${relationId}`
            : "",
          frame_lens_index: "",
          frame_dimensions: value.properties.frame_dimensions,
        };
        
        // set `lens` properties (if provided)
        if (value.properties.lens_type !== undefined) {
          itemLens = {
            lens_type_prescription: value.properties.lens_type,
            lens_usage: value.properties.lens_type == "Readers" ? "" : value.properties.lens_usage,
            is_lens_prescription: value.properties.tax_variant == "Prescription" ? "Yes" : "No",
            lens_power: value.properties.lens_type == "Readers" ? value.properties.lens_usage : ""
          };
        }

        // set `lens_color` properties (if provided)
        if (value.properties.lens_option !== undefined) {
          itemLensColor = {
            lens_type_color: value.properties.lens_option_group ?? "",
            lens_color: value.properties.lens_option ?? ""
          };
        }

        break;
    }

    if (
      value.properties.line_type == "case_id" ||
      value.properties.line_type == "others"
    ) {
      if (value.properties.line_type == "others") {
        lineGroups.push({
          line_group_id: parseInt(value.line_group_id),
          quantity: parseInt(value.quantity),
          line_id: value.id,
          title: value.title,
          discount: parseInt(value.discounted_price),
          price: parseInt(value.price),
          relation_id: value.properties.relation_id,
          is_plate: value.properties.is_plate,
        });
      } else {
        lineGroups.push({
          line_group_id: parseInt(value.line_group_id),
          quantity: parseInt(value.quantity),
          relation_id: relationId,
          user_is_under_18: false,
          lens_exchange: "",
          frame: itemFrame,
          lens: itemLens,
          lens_color: itemLensColor,
          case: itemCase,
          plates: itemPlate,
        });
      }

      // reset all line group variables
      itemPlate = [];
      itemCase = "";
      itemLensColor = "";
      itemFrame = "";
      itemLens = "";
      relationId = "";
    }
  });
  // console.log("lineGroups: ", lineGroups);
  // console.log("<<< END generateLineGroups!!!");

  return lineGroups;
}

/**Lense Options Modal
 */
const addToCartBtn = document.querySelector(".js-add-to-cart.product-select-lenses");
const optionsModal = document.querySelector(".js-options-modal");
const optionsModalButton = document.querySelector(".js-options-modal-button");
const optionsModalClose = document.querySelectorAll(".js-options-close");
const subBodyVar = document.querySelector("body");
const pageContent = document.querySelector("#page-content");
const progressButton = document.querySelectorAll(".js-progress-button");
const progressBodyItem = document.querySelectorAll(
  ".progress--body .body-item"
);
const progressBodyWrapper = document.querySelector(".progress--body-wrapper");
const drawerPrice = document.querySelector(".price--action");
const optionSelections = document.querySelectorAll(".js-option-selection");
let lensTypePrice = 0;

(function () {
  const groupBy = (items, key) => items.reduce(
    (result, item) => ({
      ...result,
      [item.properties[key]]: [
        ...(result[item.properties[key]] || []),
        item,
      ],
    }), 
    {},
  );

  fetch("/cart.js").then(res => res.json()).then(res => {
    if (
      (optionsModalButton !== null && optionsModalButton !== undefined) ||
      (addToCartBtn !== null && addToCartBtn !== undefined)
      ) {
      const cartItems = groupBy(res.items, "line_group_id");

      if (Object.entries(cartItems).length > 3) {
        const btn = optionsModalButton ?? addToCartBtn;
        
        btn.setAttribute("disabled", true);
        btn.classList.add("disabled");

        const notice = document.querySelector(".js-cart-limit-notice");
        notice.style.display = "block";
      }
    }
  });
})();

const drawerSlider = (el, wrapper) => {
  header_footer_height =
    $(".progress--body-group .item--content .text").height() +
    180 +
    $(".template-product .drawer--group .drawer--price").height();
  $(".option-div-holder").css(
    "max-height",
    `calc(${window.innerHeight}px - ` + header_footer_height + "px)"
  );

  $(window).resize(() => {
    $(".option-div-holder").css(
      "max-height",
      `calc(${window.innerHeight}px - ` + header_footer_height + "px)"
    );
  });
      
  el.forEach((element) => {
    element.addEventListener("click", () => {
      let bodyContent = element.getAttribute("data-body-content");
      let bodyId = document.querySelector("#" + bodyContent);
      let bodyTranslate = bodyId.getAttribute("data-translate");
      wrapper.style.transform =
        "translateX(" +
        (bodyTranslate == 0 ? bodyTranslate : bodyTranslate * -1) +
        "px)";
      // addShadow();
    });
  });
};

const drawerTranslate = (el) => {
  let primElOffset = 0;

  el.forEach((element) => {
    let elRect = element.offsetLeft;

    if (i == 0) {
      primElOffset = elRect;
    }

    element.setAttribute("data-translate", Math.floor(elRect - primElOffset));
    i++;
  });
};

var platePrice = 0;

if (optionsModalButton) {
  optionsModalButton.addEventListener("click", () => {
    optionsModal.classList.add("show");
    subBodyVar.classList.add("on-modal");
    pageContent.classList.add("on-modal");
    optionsModal.querySelector(".options--drawer").classList.add("show");
    document.body.style.overflow = "hidden";
    resetModal();
  });

  optionsModalClose.forEach((el) => {
    el.addEventListener("click", () => {
      optionsModal.classList.remove("show");
      subBodyVar.classList.remove("on-modal");
      pageContent.classList.remove("on-modal");
      optionsModal.querySelector(".options--drawer").classList.remove("show");
      document.body.style.overflow = "auto";
      resetModal();
      resetPlateObjects();
    });
  });

  optionSelections.forEach((el) => {
    el.addEventListener("change", (e) => {
      let optionName = e.target.getAttribute("data-product-option");
      let targetValue = e.target.value;
      let price = document.querySelector(".theme-money-modal");
      let ii = 0;
      let jj = 0;
      let total = 0;

      for (let i = 0; i < products.length; i++) {
        if (products[i].name == optionName && ii == 0) {
          ii = 1;

          for (let j = 0; j < products[i].products.length; j++) {
            if (products[i].products[j].handle == targetValue && jj == 0) {
              jj = 1;

              for (
                let k = 0;
                k < products[i].products[j].variants.length;
                k++
              ) {
                if (products[i].products[j].variants[k].name == tax_variant) {
                  lensTypePrice = products[i].products[j].variants[k].price;
                }
              }
            }
          }
        }
      }

      if (optionName === plate) {
        if (selected_plates.includes(targetValue)) {
          platePrice += lensTypePrice
        } else {
          platePrice -= lensTypePrice
        }
      } else {
        price.setAttribute("data-" + optionName + "-price", lensTypePrice);
      }

      for (let i = 1; i < price.attributes.length; i++) {
        total = Number(price.attributes[i].value) + total;
      }

      total += Number(platePrice);

      price.innerHTML = theme.Shopify.formatMoney(
        total,
        "${{amount_no_decimals}}",
        theme.money_format_with_code_preference
      );

      if (optionName == "case") {
        drawerPrice.classList.remove("hidden");
      }

      addShadow();
    });
  });

  drawerSlider(progressButton, progressBodyWrapper);
  drawerTranslate(progressBodyItem);
}

/** Product List Grid Items
 */
const swatchItem = document.querySelectorAll(".product-swatch-item");

if (swatchItem) {
  swatchItem.forEach((el) => {
    el.addEventListener("click", () => {
      let productId = el.getAttribute("data-id");
      let productImage = document.querySelector("#" + productId);
      let productSiblings = $("#" + productId).siblings(".image");

      if (productImage && productSiblings.length > 0) {
        productImage.classList.remove("hidden");

        for (let i = 0; i < productSiblings.length; i++) {
          productSiblings[i].classList.add("hidden");
        }
      }
    });
  });
}

/**
 * Function to set multiple attributes of an HTML element
 *
 * @param {element} elementToSet
 * @param {array} multipleAttributes
 */
function setMultipleAttributes(elementToSet, multipleAttributes) {
  for (var key in multipleAttributes) {
    elementToSet.attr(key, multipleAttributes[key]);
  }
}

/**
 * Function to dump multiple attributes of an HTML element (via console)
 *
 * @param {element} elementToDump
 * @param {array} multipleAttributes
 */
function dumpMultipleAttributes(elementToDump, multipleAttributes) {
  for (var key in multipleAttributes) {
    // console.log(key, elementToDump.attr(key));
  }
}

/**
 * Function to evaluate a wishlist (if it needs to be added)
 *
 * @param {element} elementToEval
 */
function evaluateWishList(elementToEval) {
  var inWishlist = false;

  window._swat.fetch(function (wishlist) {
    $.each(wishlist, function (key, value) {
      if (
        value.empi == elementToEval.attr("data-product-id") &&
        value.epi == elementToEval.attr("data-variant-id")
      ) {
        inWishlist = true;
        return false;
      }
    });
    if (inWishlist) {
      elementToEval.addClass("disabled swym-added");
    } else {
      elementToEval.removeClass("disabled swym-added");
    }
  });

  // make sure to display `Add to Favorites` button
  elementToEval.css("display", "block");
}

/**
 * Function to reset any variables within the modal
 */
function resetModal() {
  // for `Select Frame Size` screen
  let frameSizeOptions = $(".product-item-size");

  // reset variant
  selected_variant = {
    frame_id: "",
    lens_type_id: "",
    lens_option_id: "",
    plate_id: [],
    case_id: "",
  };

  // reset selected radio button
  $.each(selected_variant, function (key, value) {
    $('input[name="' + key + '"]').prop("checked", false);
  });

  // reset frame size selection
  $(".js-product-item-size").removeClass("active");
  $(".progress--body-wrapper").css("transform", "translateX(0px)");

  tax_variant = 'Prescription';

  // update variant IDs for frame ONLY
  if (frameSizeOptions.length == 1) {
    getProductInfo($('.js-product-item-size').data('productid'), tax_variant, products[3]);
  } else {
    getProductInfo($('.js-product-item-size.active').data('productid'), tax_variant, products[3]);
  }

  // evaluate screens in PDP modal
  evaluateScreenInModal();

  // reset subtotal in modal
  resetModalSubtotal();

  // clear item validation
  toggleItemValidation('');
}

/**
 * Function to evaluate screens in PDP modal
 *
 * - possible metafield options/element ID values:
 *   > Select Frame Size (NA/framesize)
 *   > Select Lens Type & Usage (lens_type_usage/lenstype)
 *   > Select Lens Option (lens_options/lensoption)
 *   > Select Case (case/case)
 */
function evaluateScreenInModal() {
  let frameSizes = "";

  // monitor color swatch
  let colorOptions = document.querySelectorAll(".js-option-color");
  $.each(colorOptions, (key, value) => {
    if ($(value).hasClass("active")) {
      selected_color = value.dataset.value;
      return false;
    }
  });


  $.each(productGroup, (key, value) => {
    if (value.hasOwnProperty(selected_color)) {
    
      frameSizes = value[selected_color];
      return false;
    }
  });

  // set default product's variant (if selected product has ONLY 1 frame size)
  if (frameSizes.length == 1) {
    if (
      selected_product.hasOwnProperty("frame") &&
      selected_product.frame.hasOwnProperty("variants")
    ) {
      selected_variant.frame_id = selected_product.frame.variants[0].id;
    } else {
      if (currentProductVariant[0].hasOwnProperty("prescription")) {
        selected_variant.frame_id = currentProductVariant[0].prescription.id;

        // set `selected_product`.`frame`
        $.each(products[3].products, (key, value) => {
          if (value.id == currentProductVariant[0].id) {
            selected_product.frame = value;
            return false;
          }
        });
      }
    }

    // hide `Select Frame Size` screen
    modal_screen.framesize = false;
  } else {
    // show `Select Frame Size` screen
    modal_screen.framesize = true;
  }

  // set modal screen(s)
  setModalScreen();
}

/**
 * Function to show/hide screens in PDP modal
 */
function setModalScreen() {

  // check selected product's options (if exists)
  if (
    selected_product.hasOwnProperty("frame") &&
    selected_product.frame.hasOwnProperty("options")
  ) {
    let selectedProductOptions = selected_product.frame.options;
    // hide `Select Lens Type & Usage` screen
    if (!selectedProductOptions.hasOwnProperty("lens_type_usage")) {
      modal_screen.lenstype = false;
    } else {
      // evaluate `Lens Type & Usage`
      let arr = selectedProductOptions.lens_type_usage.split(";");
      // if there is ONLY 1 option
      if (arr.length == 1) {
        modal_screen.lenstype = false;

        updateFrameVariant(arr[0]);
      } else {
        modal_screen.lenstype = true;
      }
    }

    // hide `Select Lens Option` screen
    if (!selectedProductOptions.hasOwnProperty("lens_options")) {
      modal_screen.lensoption = false;
    } else {
      modal_screen.lensoption = true;
    }

    // hide `Select Plates` screen
    if (!selectedProductOptions.hasOwnProperty("plates")) {
      modal_screen.plate = false;
    } else {
      modal_screen.plate = true;
    }

    // hide `Select Case` screen
    if (!selectedProductOptions.hasOwnProperty("case")) {
      modal_screen.case = false;
    } else {
      modal_screen.case = true;
    }
  }

  $.each(modal_screen, function (key, value) {
    let screenInModal = $("#" + key);

    if (!value) {
      screenInModal.hide();
    } else {
      screenInModal.show();
    }
  });

  drawerSlider(progressButton, progressBodyWrapper);
  drawerTranslate(progressBodyItem);

  // set screen transition
  setScreenTransition();

}

/**
 * Function to set dynamic transition for screen(s) in modal
 */
function setScreenTransition() {
  let screenTransition = screen_transition.framesize;
  // for `Select Frame Size` screen
  let frameSizeOptions = $(".product-item-size");

  if (modal_screen.lenstype == true) {
    screenTransition = screen_transition.framesize;
  } else if (modal_screen.lensoption == true) {
    screenTransition = screen_transition.lenstype;
  } else  if (modal_screen.plate == true) {
    screenTransition = screen_transition.lensoption;
  } else  if (modal_screen.case == true) {
    screenTransition = screen_transition.plate;
  }


  // update all frame size options attributes
  $.each(frameSizeOptions, function (key, value) {
    value.dataset.bodyContent = screenTransition.bodyContent;
    value.dataset.nextSlide = screenTransition.nextSlide;
  });

  // for `Select Lens Type & Usage` screen
  let lensTypeContainer = $("#lenstype");
  let lensTypeBackButton = lensTypeContainer
    .find("div.selector-wrapper")
    .find("span.option-back");
  let lensTypeOptions = lensTypeContainer.find("input.js-option-selection");

  // make sure to toggle correct screen (especially when `Readers` have been selected previously)
  toggleReaderLensPower();

  // show/hide back button
  if (!modal_screen.framesize) {
    lensTypeBackButton.hide();
  } else {
    lensTypeBackButton.show();
  }

  if (modal_screen.lensoption == true) {
    screenTransition = screen_transition.lenstype;
  } else {
    if (modal_screen.case == true) {
      screenTransition = screen_transition.lensoption;
    }
  }

  // update all lens type & usage options attributes
  $.each(lensTypeOptions, function (key, value) {
    // exclude option "READERS"
    if (value.value != "readers") {
      value.dataset.nextSlide = screenTransition.nextSlide;
    }
  });

  // for `Select Option` screen
  let lensOptionContainer = $("#lensoption");
  let lensOptionBackButton = lensOptionContainer.find("span.option-back");
  let lensOptions = lensOptionContainer.find("input.js-option-selection");

  // show/hide back button
  if (!modal_screen.framesize && !modal_screen.lenstype) {
    lensOptionBackButton.hide();
  } else {
    lensOptionBackButton.show();
  }

  if (modal_screen.case == true) {
    screenTransition = screen_transition.lensoption;
  }
  // update all lens option options attributes
  $.each(lensOptions, function (key, value) {
    value.dataset.nextSlide = screenTransition.nextSlide;
  });

  // for `Select Case` screen
  let caseContainer = $("#case");
  let caseBackButton = caseContainer.find("span.option-back");

  // show/hide back button
  if (
    !modal_screen.framesize &&
    !modal_screen.lenstype &&
    !modal_screen.lensoption
  ) {
    caseBackButton.hide();
  } else {
    caseBackButton.show();
  }
}

/**
 * Function to reset subtotal in PDP modal
 */
function resetModalSubtotal() {
  let total = 0;
  let price = document.querySelector(".theme-money-modal");

  $.each(price.dataset, function (key, value) {
    if (key == "currentPrice") {
      total = Number(value);
    } else {
      // reset other attributes
      price.dataset[key] = 0;
    }
  });

  price.innerHTML = theme.Shopify.formatMoney(
    total,
    "${{amount_no_decimals}}",
    theme.money_format_with_code_preference
  );

  if (!product.tags.includes("plate-product") && !product.tags.includes("Sunglasses")) {
    // hide `Add to Cart` button
    $(".js-add-to-cart").hide();
  }
}

/**
 * Function to show/hide `Select Reader Lens Power` screen
 *
 * @param {boolean} $isVisible
 */
function toggleReaderLensPower(isVisible = false) {
  if (!isVisible) {
    $(".js-option-lens-usage").css("left", "100%");
    $("#lenstype .option--lens-type").css("right", "0");
    $(".js-option-lens-usage").hide();
  } else {
    $(".js-option-lens-usage").css("left", "0");
    $("#lenstype .option--lens-type").css("right", "100%");
    $(".js-option-lens-usage").show();
  }
}

/**
 * Function to update frame and lens type variants
 *
 * @param {string} lensType
 */
function updateFrameVariant(lensType) {
  switch (lensType) {
    case "single-vision":
      toggleReaderLensPower();

      lensUsage = "Distance";
      tax_variant = "Prescription";
      break;

    case "progressive":
      toggleReaderLensPower();

      lensUsage = "";
      tax_variant = "Prescription";
      break;

    case "readers":
      toggleReaderLensPower(true);

      tax_variant = "Non-Prescription";
      break;

    case "non-prescription":
    case "non-prescription-only":
      toggleReaderLensPower();

      lensUsage = "";
      tax_variant = "Non-Prescription";
      break;

    default:
      toggleReaderLensPower();

      lensUsage = "";
  }

  // set correct `Lens Type & Usage` variant
  getProductInfo(lensType, tax_variant, products[0]);

  // for `Select Frame Size` screen
  let frameSizeOptions = $(".product-item-size");

  // update variant IDs for frame ONLY
  if (frameSizeOptions.length == 1) {
    getProductInfo(
      $(".js-product-item-size").data("productid"),
      tax_variant,
      products[3]
    );
  } else {
    getProductInfo(
      $(".js-product-item-size.active").data("productid"),
      tax_variant,
      products[3]
    );
  }
}

/**
 * Function to remove items from the cart given its `line_group_id`
 *
 * @param {number} lineGroupId
 */
async function removeCartItem(lineGroupId) {
    // initialize variable for new cart item(s)
    var newCartItems = {
        items: [],
    };

    for (const value of cartItems) {
        var itemLineGroup = parseInt(value.line_group_id);
        var itemLineID = parseInt(value.id);
        // evaluate ONLY cart items having different `line_group_id`
        if(lineGroupId && (itemLineGroup != lineGroupId)){
            var itemProperties = value.properties;
            // current `line_group_id` is greater than the removed item's `line_group_id`
            if (itemLineGroup > lineGroupId) {
                // decrement line group id by 1 (if )
                itemProperties.line_group_id = itemLineGroup - 1;
            }

            // push new cart item
            newCartItems["items"].push({
                id: value.id,
                quantity: value.quantity,
                properties: itemProperties,
            });
        }
    }

  // clear cart items
  await fetch(shopifyCartClearUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    }
  })
  .then(() => {
    // insert new set of cart items
    fetch(shopifyCartAddUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newCartItems),
    })
    .then((data) => {
      window.location.href = shopifyCartUrl;
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  })
  .catch((error) => {
    console.error("Error:", error);
  });
}


function initColorSwatchToURL() {
  // check if currently viewing main_product.liquid
  if(window.location.href.indexOf('/products/') === -1) {
    return;
  }

  let product_handle = product.handle;
  let links = [];
  let collections = [];

  const extractProductCollections = function() {
    return products.filter(function(p) { return p.handle === product_handle });
  }

  const generateArrayKey = function(val) {
    return val.trim().replace(' ', '-').toLowerCase();
  };
  const generateLinks = function(items) {
    const links = [];

    let loc = window.location.href.split('/');
    loc = loc.slice(0, -1);

    items.forEach(function (p) {
      const k = generateArrayKey(p.custom_attributes['frame-color']);
      links[k] = {
        handle: p.handle,
        color: p.custom_attributes['frame-color'],
        link: loc.join('/') + '/' + p.handle,
        hasCustomDisplay: p.metafields['disp_name'] !== null && p.metafields['disp_name'] !== '' && p.metafields['disp_name'] !== undefined,
        customPriceDisplay: p.metafields['disp_name'],
        price: p.metafields['disp_name'] ?? (p.variants[0].price/100) + '',
        defaultPrice: p.variants[0].price
      };
    });

    return links;
  };

  const constructPriceHtml = function(str_val, isCustomDisplay = false) {
    if(!str_val) return '';

    if(isCustomDisplay === false) {
      return theme.Shopify.formatMoney(
          str_val,
          "${{amount_no_decimals}}",
          theme.money_format_with_code_preference
      );
    }

    const _strs = str_val.split(' ');
    const _label = _strs.slice(0, -1);
    const _price = _strs.slice(-1)[0].replace('$', '');
    let pretext = '';

    if(_label.length > 0) {
      pretext = '<span style="font-size: 16px; line-height: 0;margin-right: 5px;">'+ _label.join(' ') +'</span>';
    }

    return pretext + ' $' + _price;
  }

  const updateSubTotalDisplay = function(target) {
    const parent = document.querySelector('.js-options-modal'); //  .js-total-price
    const elem = parent.querySelector(".theme-money-modal");

    const _price = links[target].defaultPrice;
    elem.dataset.currentPrice = _price;
}

  const updatePriceDisplay = function(target) {
    const parent = document.querySelector(".js-pdp-price");
    const elem = parent.querySelector(".price");
    const hasCustomDisplay = links[target].hasCustomDisplay;
    let price = links[target].defaultPrice;

    if(hasCustomDisplay) {
      price = links[target].customPriceDisplay;
    }

    const html_price = constructPriceHtml(price, hasCustomDisplay);
    elem.innerHTML = html_price;
  }

  const updateAddressBar = function(target) {
    history.replaceState({}, '', links[target].link);
  }

  const colorHandler = function(i) {
    const k = generateArrayKey(this.getAttribute('data-value'));
    updatePriceDisplay(k);
    updateSubTotalDisplay(k);
    updateAddressBar(k);
    
    const sku = document.querySelector(".js-pdp-specs-sku");
    const featured = document.querySelector(".js-pdp-specs-featured");
    const title = document.querySelector("span.product-featured-title");
    const breadcrumb = document.querySelector("a.bc-link.product-current");

    $(sku).next().text(selected_product.frame.variants[0].sku);
    $(featured).next().text(selected_product.frame.custom_attributes.featured || '');
    $(title).text(selected_product.frame.title);
    $(breadcrumb).text(selected_product.frame.title);
    showVtoBtnInPDP();
  }
  const activateSwatchListeners = function() {
    document.querySelectorAll('.js-option-color').forEach(function(color) {
      color.addEventListener('click', colorHandler);
    });
  };

  // collect product urls for color swatch
  collections = extractProductCollections();


  let attempts = 3;
  while(!collections.length && attempts > 0) {
    product_handle = product_handle.split('-').slice(0, -1).join('-');
    collections = extractProductCollections();
    attempts -= 1;
  }

  if(attempts == 0 && collections.length == 0) {
    console.log('Possible problem with collection data, please check collection handle and product handle');
  }

  links = generateLinks(collections[0].products);

  activateSwatchListeners();
}

/**
 * Function to toggle notification for item validation
 *
 * @param {string} errorMessage
 */
function toggleItemValidation(errorMessage) {
  if (errorMessage !== '') {
    // close modal
    optionsModalClose[0].click();

    $("#item_validation").text(errorMessage);
    $("#item_validation").removeClass("visually-hidden");
  } else {
    $("#item_validation").text(errorMessage);
    $("#item_validation").addClass("visually-hidden");
  }

  // reset `Add to Cart` label
  // reset `addedToCart` as false
  addedToCart = false;
}
function showVtoBtnInPDP() {
  var currentURL = window.location.href;

  if (
    currentURL.indexOf("/products") > -1 &&
    currentURL.indexOf("utm_campaign=") > -1 &&
    currentURL.indexOf("&from=qr_code") > -1
  ) {
    const oldVtoButton = document.querySelectorAll("#vto-btn");

    // Loop through the NodeList and remove each element
    oldVtoButton.forEach(function (element) {
      element.remove();
    });
    return;
  }
  // Select all elements with the same ID

  setTimeout(() => {
    const oldVtoButton = document.querySelectorAll("#vto-btn");

    // Loop through the NodeList and remove each element
    oldVtoButton.forEach(function (element) {
      element.remove();
    });
    var newButton = document.createElement("button");
    newButton.id = "vto-btn";
    newButton.textContent = "Virtual Try On";

    document
      .getElementsByClassName("swiper-pagination")[0]
      .insertAdjacentElement("beforebegin", newButton);
    // Triger the original button
    newButton.addEventListener("click", function () {
      document.getElementById("jsOpenFitMixModal").click();
    });
  }, 50);
}
function pdpChanges() {
  // add your JavaScript changes here
  var currentURL = window.location.href;

  // add your JavaScript changes here
  if (currentURL.indexOf('/products') > -1
    && currentURL.indexOf('utm_campaign=') > -1
    && currentURL.indexOf("&from=qr_code") > -1) {
    return;
  }
  // Change 'Add to cart' text based on product properties
var addCart = document.getElementsByClassName("product-select-lenses")[0];
const isDisableBtn = $(".product-select-lenses").prop("disabled");

if (!isDisableBtn) {
  let currentProduct = currentProductVariant[0];

  // Check product title for "multi size" (case-insensitive)
  if (currentProduct.title.toLowerCase().includes("multi size")) {
    addCart.textContent = "Select Frame Size";
  } else if (
    currentProduct.hasOwnProperty("lens_type") &&
    currentProduct.lens_type?.split(";")?.length > 1
  ) {
    addCart.textContent = "Select Lenses";
  } else if (currentProduct.hasOwnProperty("case")) {
    addCart.textContent = "Select Case";
  } else {
    addCart.textContent = "Add To Cart";
  }
}

  // Create new 'Virtual Try On' button under the product image slider
  const listBtnVto = document.querySelectorAll(
    ".swiper-container-horizontal #vto-btn"
  );
  if (typeof listBtnVto === "undefined" || listBtnVto?.length === 0) {
    showVtoBtnInPDP();
  }

  // Add 'Added to favorites' tooltip text
  const parentDiv = document.getElementById("add-to-favorites");
  const tooltipSpan = document.createElement("span");
  tooltipSpan.classList.add("tooltiptext");
  tooltipSpan.textContent = "Added to favorites";
  const nestedI = document.createElement("i");
  tooltipSpan.appendChild(nestedI);
  parentDiv.appendChild(tooltipSpan);
  // Show 'Added to favorites' text with a click event listener
  var addToFev = document.getElementById("add-to-favorites");
  var tooltip = document.querySelector(".tooltiptext");
  addToFev.addEventListener("click", function () {
    addToFev.classList.toggle("swym-added");
    if (addToFev.classList.contains("swym-added")) {
      tooltip.style.transition = "opacity 0.5s";
      setTimeout(() => {
        tooltip.style.visibility = "visible";
        tooltip.style.opacity = "1";
      }, 500);
      setTimeout(() => {
        tooltip.style.opacity = "0";
        setTimeout(() => {
          tooltip.style.visibility = "hidden";
        }, 500);
      }, 3000);
    }
  });
}